import React from "react";

const UncheckedIcon = () => (
  <svg width="14" height="14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x=".75" y=".75" width="12.5" height="12.5" rx="1.25" stroke="currentColor" strokeOpacity=".87" strokeWidth="1.5" />
  </svg>
);

export default UncheckedIcon;
